module.exports = __webpack_public_path__ + "static/media/error.4d158b49.mp3";